import ReactPaginate from 'react-paginate';
import DropdownItem from 'react-bootstrap/DropdownItem';
import CustomDropdown from '../dropdown/CustomDropDown';
import styled, { css } from 'styled-components';
import NewDropDownIcon from '../svgIcons/NewDropDownIcon';
import RefetchIcon from '../svgIcons/RefetchIcon';
import { useState } from 'react';
import './_pagination.scss';

const NewPaginationPerPage = ({
  paginationData,
  onPerPageChange,
  onPageChange,
  onRefetch = () => {},
  hideText = false,
  changeInPageNumber
}) => {
  const [iconRotation, setIconRotation] = useState(0);

  const handleRefetchClick = () => {
    setIconRotation((prevState) => prevState + 360);
    onRefetch();
  };

  const pageSizes = changeInPageNumber ? [28, 50, 75, 100] : [5, 10, 20, 50];
  return (
    <StyledPaginationContainer className="d-flex flex-column-reverse flex-md-row text-gray align-items-center justify-content-between mt-2 mt-md-4">
      <div className="d-flex align-items-center">
        {!hideText && (
          <h6 className="m-0 me-2">
            <span className="me-1">Showing</span>
            <span>
              {paginationData?.number
                ? paginationData?.number * paginationData?.size + 1
                : 1}
            </span>
            <span className="mx-1">to</span>
            <span>
              {((paginationData?.number ?? 0) + 1) *
                (paginationData?.size ?? 0) >
              (paginationData?.totalElements ?? 0)
                ? paginationData?.totalElements ?? 0
                : ((paginationData?.number ?? 0) + 1) *
                  (paginationData?.size ?? 0)}
            </span>
            <span className="mx-1">of</span>
            <span>{paginationData?.totalElements || 0}</span>
            <span className="mx-1">entries</span>
            {/*{`${*/}
            {/*  paginationData?.number*/}
            {/*    ? paginationData?.number * paginationData?.size + 1*/}
            {/*    : 1*/}
            {/*} to ${*/}
            {/*  (paginationData?.number + 1) * paginationData?.size >*/}
            {/*  paginationData?.totalElements*/}
            {/*    ? paginationData?.totalElements*/}
            {/*    : (paginationData?.number + 1) * paginationData?.size*/}
            {/*} of ${paginationData?.totalElements || 0}`}{' '}*/}
            {/*entries*/}
          </h6>
        )}
        <CustomDropdown
          dropdownToggle={
            <span className="flex-center _dropdown-toggle-btn">
              <h6 className="me-2 me-lg-3 mb-0">
                {paginationData?.size || ''}
              </h6>
              <NewDropDownIcon className={'ms-1'} />
            </span>
          }
          toggleClassName="p-0"
          dropdownMenu={
            <>
              {pageSizes.map((p) => (
                <DropdownItem key={p} onClick={() => onPerPageChange(p)}>
                  {p}
                </DropdownItem>
              ))}
            </>
          }
        />
        <SyledRotateIcon
          className="mx-2 cursor-pointer"
          onClick={handleRefetchClick}
          iconRotation={iconRotation}
        >
          <RefetchIcon className={`mx-1`} />
        </SyledRotateIcon>
      </div>
      <div className="mb-3 mb-md-0">
        <ReactPaginate
          pageCount={paginationData?.totalPages || 0}
          onPageChange={onPageChange}
          forcePage={paginationData?.number}
          marginPagesDisplayed={1}
          containerClassName="pagination__container"
          pageLinkClassName="pagination__page"
          previousClassName="pagination__page-prev-next"
          nextClassName="pagination__page-prev-next"
          previousLabel={<span>Previous</span>}
          nextLabel={<span>Next</span>}
          activeLinkClassName="pagination__page-active"
        />
      </div>
    </StyledPaginationContainer>
  );
};

const StyledPaginationContainer = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.bodyMedium};
  h6,
  span {
    font-family: ${({ theme }) => theme.fontFamily};
    color: ${({ theme }) => theme.bodyMedium};
  }
  h6 {
    font-size: 18px;
    font-weight: 400;
    ${({ theme }) => css`
      @media (max-width: ${theme?.breakpoints?.md}px) {
        font-size: 14px;
      }
    `}
  }
  .custom-drop-down {
    .menu-toggle {
      border: 1.5px solid ${({ theme }) => theme.dark70};
      color: ${({ theme }) => theme.dark40};
      background-color: ${({ theme }) => theme.transparent};
      ._dropdown-toggle-btn {
        padding: 7px 9px;
      }
    }
  }

  ul {
    &.pagination__container {
      li {
        a {
          display: flex;
          align-items: center;
          span {
            color: ${({ theme }) => theme.dark40};
            font-weight: 400;
            font-size: 18px;
           
          }
          &:hover {
            background-color: ${({ theme }) => theme.primary};
            span {
              color: ${({ theme }) => theme.white};
            }
          }
          &.pagination__page {
            font-size: 18px;
            font-weight: 400;
            color: ${({ theme }) => theme.bodyMedium};
            border: 1.5px solid;
            border-color: ${({ theme }) => theme.dark70};
            &.pagination__page-active, &:hover {
              font-weight: 600;
              border-color: ${({ theme }) => theme.primary};
              color: ${({ theme }) => theme.white};
            }
            ${({ theme }) => css`
              @media (max-width: ${theme?.breakpoints?.md}px) {
                font-size: 14px;
                padding: 1px 10px;
              }
            `}
          }
        }
        &.disabled {
          a {
            span {
              color: ${({ theme }) => theme.dark60};
            }
          }
        }
        &.pagination__page-prev-next {
          margin: 0;
          a {
            ${({ theme }) => css`
              @media (max-width: ${theme?.breakpoints?.md}px) {
                span {
                  font-size: 14px;
                }
                padding: 1px 10px;
              }
            `}
          }
        }
        &.selected {
          a {
            background-color: ${({ theme }) => theme.primary};
            border-color: ${({ theme }) => theme.primary}!important;
            color: ${({ theme }) => theme.white};
          }
        }
        &.break {
          a {
            padding: 1px 10px;
            border-radius: 8px;
            border: 1.5px solid;
            border-color: ${({ theme }) => theme.dark70};
            &:hover {
              color: ${({ theme }) => theme.white};
              border-color: ${({ theme }) => theme.primary};
            }
          }
          }
        }
      }
    }
  }
`;
const SyledRotateIcon = styled.div`
  transition: transform 0.7s ease-in-out;
  transform: rotate(${({ iconRotation }) => iconRotation}deg);
`;
export default NewPaginationPerPage;
